module.exports = __webpack_public_path__ + "img/9bd6fa1.jpg";